// extracted by css-extract-rspack-plugin
export default {"sectionWidth":"sectionWidth-m5MHiy"};